import { render, staticRenderFns } from "./LabContactsTab.vue?vue&type=template&id=19720dbd"
import script from "./LabContactsTab.vue?vue&type=script&lang=js"
export * from "./LabContactsTab.vue?vue&type=script&lang=js"
import style0 from "./LabContactsTab.vue?vue&type=style&index=0&id=19720dbd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports